/**
 * Animation interpolation method.
 */
export enum InterpolationType {
  /** Linear interpolation */
  Linear,
  /** Cubic spline interpolation */
  CubicSpine,
  /** Stepped interpolation */
  Step,
  /** Hermite interpolation */
  Hermite
}
